import React from 'react'
import clsx from 'clsx'
import { RichTextField } from '@/components/organisms/RichTextField/RichTextField'
import { CustomLink } from '@/components/atoms/CustomLink/CustomLink'
import { Image } from '@/components/atoms/Image/Image'
import { FeatureCardProps } from '@/components/molecules/FeatureCard/types'
import AdvBgImage2 from '@/assets/icons/advatages-grid-item-bg-2.svg'
import AdvBgImage from '@/assets/icons/advatages-grid-item-bg.svg'

export function FeatureCard({ card_heading, card_description, cta_link, card_image, index = 0 }: FeatureCardProps) {
  return (
    <div className="flex flex-col netbook:flex-row justify-between items-center py-32 desktop:py-40">
      <div className="flex flex-col gap-16 tablet:gap-24 w-full netbook:w-5/12 text-text-dark-900 ">
        <h3 className="text-headingM-mobile font-bold font-poppins mx-auto w-full netbook:text-[28px]">
          {card_heading}
        </h3>
        <div className="[&>p.richtext-content]:!text-text-dark-600 [&>p.richtext-content>span]:!text-text-dark-600 [&>p.richtext-content]:text-bodyL [&>p.richtext-content>span]:text-bodyL">
          <RichTextField data={card_description} />
        </div>
        {cta_link.length > 0 && (
          <CustomLink {...cta_link[0]} className="mb-16 mt-8 font-poppins netbook:mt-16 netbook:mb-0">
            <span className="text-text-dark-900 font-bold text-bodyL hover:text-text-dark-600">
              {cta_link[0]?.text}
            </span>
            <i className={clsx('fa fa-thin-arrow-right text-text-dark-900 hover:text-text-dark-600 ml-8')} />
          </CustomLink>
        )}
      </div>
      {card_image && (
        <div className="relative w-full netbook:w-6/12 netbook:max-w-6/12 flex flex-col px-20 py-28 tablet:px-32 tablet:py-36 bg-white rounded-xl tablet:rounded-3xl shadow-feature self-start mt-20 netbook:my-auto">
          {index % 2 === 0 ? (
            <img className="absolute w-28 -left-8 -top-8 -z-1" src={AdvBgImage2} alt="adventages-bg" />
          ) : (
            <img className="w-full absolute -right-40 -top-28 -z-1" src={AdvBgImage} alt="adventages-bg" />
          )}
          <Image fixed={false} fluid data={card_image} className="rounded" />
        </div>
      )}
    </div>
  )
}
